/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import { post, CashRequestOptions } from '@cash-web/shared-util-fetch'
import {WebDeviceInfoRequest} from '@cash-web/protos/squareup/cash/cashdotapp/app.pb'
import {WebDeviceInfoResponse} from '@cash-web/protos/squareup/cash/cashdotapp/app.pb'


export const webDeviceInfo = (request: WebDeviceInfoRequest, options?: CashRequestOptions) => post<WebDeviceInfoRequest, WebDeviceInfoResponse>("/2.0/cash/web/device-info", request, {...options, rejectOnError: true })